import { applyMiddleware, compose, createStore } from "redux";
import { createEpicMiddleware } from "redux-observable";
import { BehaviorSubject } from "rxjs";
import { switchMap } from "rxjs/operators";
import rootEpics from "./epics";
import rootReducer from "./reducers";

const loadReduxLogger = () => import("redux-logger").then(mod => mod.createLogger());

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const epicMiddleware = createEpicMiddleware();

let store = null;

const epic$ = new BehaviorSubject(rootEpics);
const hotReloadingEpic = (...args) => epic$.pipe(switchMap(epic => epic(...args)));

export const loadStore = () => {
    const loadLazyMiddlewares = [];
    if (process.env.NODE_ENV !== "production") {
        loadLazyMiddlewares.push(loadReduxLogger());
    }
    return Promise.all(loadLazyMiddlewares).then(lazyMiddlewares => {
        const middlewares = applyMiddleware(epicMiddleware, ...lazyMiddlewares);
        store = store || createStore(rootReducer, {}, composeEnhancers(middlewares));
        epicMiddleware.run(hotReloadingEpic);
        return store;
    });
};

if (module.hot) {
    module.hot.accept("./reducers", () => {
        store.replaceReducer(rootReducer);
    });
    module.hot.accept("./epics", () => {
        const nextRootEpic = require("./epics").default;
        epic$.next(nextRootEpic);
    });
}

export const getStore = () => {
    return store;
};
